import curriculumIcon from "../../../../assets/icons/dashboard/TotalCurriculum.svg";
import groupIcon from "../../../../assets/icons/dashboard/TotalGroups.svg";
import enrollmentIcon from "../../../../assets/icons/dashboard/Total Enrollments.svg";
import CustomRadialBarChart from "../../../../components/global/CustomCharts/CustomRadialChart";
import { useNavigate } from "react-router-dom";

const DashboardCards = ({ data }) => {
  const navigate = useNavigate();
  const chartData = [
    {
      name: "In Progress",
      value: data?.inProgressCourses || 0,
      fill: "#AF79DB",
    },
    {
      name: "Not Started",
      value: data?.notStartedCourses || 0,
      fill: "#C85264",
    },
    {
      name: "Completed On Time",
      value: data?.completedOnTimeCourses || 0,
      fill: "#FFD46F",
    },
    {
      name: "Late Completion",
      value: data?.lateCompletionCourses || 0,
      fill: "#79D684",
    },
    {
      name: "Failed",
      value: data?.completionFailedCourses || 0,
      fill: "#F28080",
    },
    {
      name: "Defaulters",
      value: data?.defaulterCourses || 0,
      fill: "#5D96E7",
    },
  ];

  const redirect = (path) => {
    navigate(path);
  };

  const cardClass =
    "size-[230px] flex flex-1 flex-col justify-center items-center gap-4 shadow-[0px_0px_6px_0px_rgba(0,0,0,0.05)] p-10 rounded-[10px] cursor-pointer";

  const valueClass = "font-semibold text-[28px] text-[#E74860]";
  const labelClass = "font-medium text-[14px] text-[#8B8B8B]";

  return (
    <div className="flex gap-6">
      {/* Enrollments */}
      <div className={cardClass} onClick={()=> redirect("/my-courses")}>
        <img src={enrollmentIcon} className="size-[100px]" alt="enrollments" />
        <p className={valueClass}>{data?.enrollments ?? 0}</p>
        <p className={labelClass}>Total Enrollments</p>
      </div>

      {/* Groups */}
      <div className={cardClass} onClick={()=> redirect("/my-groups")}>
        <img src={groupIcon} className="size-[100px]" alt="group" />
        <p className={valueClass}>{data?.groups ?? 0}</p>
        <p className={labelClass}>Total Groups</p>
      </div>

      {/* Curriculums */}
      <div className={cardClass} onClick={()=> redirect("/my-courses")}>
        <img src={curriculumIcon} className="size-[100px]" alt="curriculum" />
        <p className={valueClass}>{data?.bundles ?? 0}</p>
        <p className={labelClass}>Total Curriculums</p>
      </div>

      <div className="flex flex-1 items-center gap-8 shadow-[0px_0px_6px_0px_rgba(0,0,0,0.05)] p-4 rounded-[10px]">
        <CustomRadialBarChart data={chartData} width={200} height={200} />
      </div>
    </div>
  );
};

export default DashboardCards;
